export enum RegimeApuracaoSimplesNacional {
    Caixa = 0,
    Competencia = 1,
}